<template>
  <span
    v-if="count !== null && count !== undefined"
    class="text-xs font-medium text-primary bg-surface-light flex flex-row items-center gap-1 border border-weak rounded-full px-2 py-1 whitespace-nowrap shrink-0"
  >
    {{ count > 0 ? count.toLocaleString() : '-' }}
    <AM3Icon
      type="user"
      size="sm"
    />
  </span>
</template>

<script setup lang="ts">
import AM3Icon from './icon/AM3Icon.vue'

defineProps<{
  // Number of people (subscribers, contacts, etc.) represented by this option.
  // Renders nothing when null/undefined (count not yet known); shows '-' at 0.
  count: number | null | undefined
}>()
</script>
